import css from './animated.module.scss';
import classNames from 'classnames';

export default function BoardText({cnReplace}) {
  return (
    <img loading={'lazy'} src='/board_texts.svg' alt={'img2'} className={classNames(css.img, cnReplace)}/>
  );
}